import type { ReactNode } from 'react';

/** A titled group of rows with its count. */
export function PickerSection({ title, count, children }: { title: string; count: number; children: ReactNode }) {
  return (
    <section role="group" aria-label={title}>
      <h2 className="mb-1 text-xs font-semibold tracking-wide text-muted uppercase">
        {title} ({count})
      </h2>
      <ul className="overflow-hidden rounded-lg border border-line bg-surface">{children}</ul>
    </section>
  );
}
